import {Component, EventEmitter, forwardRef, Input, Output} from '@angular/core';
import {Observable, of, tap} from "rxjs";
import {catchError, map} from "rxjs/operators";
import {BaseSelect} from "../../core/classes/base.component";
import {ProjectService} from "../../core/services/routes-services/project.service";
import {ProjectInfo} from "../../core/interfaces/project.interface";
import {RequestBody} from "../../core/interfaces/admin.interface";
import {environment} from "../../../environments/environment";
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {Type} from "../../core/interfaces/project-type.interface";

@Component({
    selector: 'app-project-select',
    // exportAs: 'ngModel', disabled until finding out how to replace #project="ngModel" attribute of <app-project-select> to render validation errors via <span *ngIf="project.invalid && (project.dirty || project.touched)">
    templateUrl: './project-select.component.html',
    styleUrls: ['./project-select.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ProjectSelectComponent),
            multi: true
        }
    ]
})
export class ProjectSelectComponent extends BaseSelect<ProjectInfo> implements ControlValueAccessor {

    @Output() selectionChanged = new EventEmitter<any>();

    requestBody: RequestBody = {
        paging: false,
        page: 0,
        rows: environment.rows,
        direction: "ASC",
        summary: true,
        filters: {
            ACCOUNT: {
                id: null,
            },
            HEADQUARTER: {
                id: null,
            },
            PROJECT_TYPE: {
                id: null,
            },
            WORKFLOW: {
                id: null,
            },
            PROJECT_VIEW: {
                projectState: null,
                percentageProgressFrom: 0,
                percentageProgressTo: 100,
                type: null,
            },
            CUSTOMER: {
                customerType: null,
            },
        },
    };

    formControl: FormControl<any>
    onChange: (value: any) => void = () => {};
    onTouched: () => void = () => {};

    constructor(
        private _service: ProjectService,
    ) {
        super(true)
        this.formControl = new FormControl()
    }

    trackByFn(item: ProjectInfo) {
        return item.id;
    }

    override executeRequest(term): Observable<any> {
        const req = this.request()
        req.filters.PROJECT_VIEW.projectName = term
        return this._service.getProjectList(req).pipe(
            map(res => {
                const { data } = res;
                return data as ProjectInfo[]
            }),
            catchError(() => of([])), // empty list on error
            tap(() => (this.loading = false)),
        )
    }

    override fill(filters: any) {
        super.fillBasicFilters(filters, 'PROJECT_VIEW')
        filters['PROJECT_VIEW'] = {
            company:  this._companyId ? [this._companyId] : null,
        }
        if(this.requestBody.filters.PROJECT_VIEW?.type != null)
            filters['PROJECT_VIEW'].type = this.requestBody.filters.PROJECT_VIEW.type
        filters['ACCOUNT'] = {
            id: this.requestBody.filters.ACCOUNT.id
        }
    }

    // @Input() @Output()
    // value: any
    onSelectionChange(ev) {
        this.selectionChanged.emit(ev)
    }

    onInput(value: any): void {
        this.value = value;
        this.selectionChanged.emit(value)
        this.onChange(value);
    }

    get value(): any {
        return this.selectedEntries;
    }

    set value(value: any) {
        this.selectedEntries = value;
        this.formControl.setValue(value, { emitEvent: false });
        // if(!value)
        //     this.formControl.reset()
    }

    @Input()
    set account(value: number) {
        this.requestBody.filters.PROJECT_VIEW.company = null;
        this.requestBody.filters.ACCOUNT.id = value;
    }

    @Input()
    set type(value: Type) {
        this.requestBody.filters.PROJECT_VIEW.type = value;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn
    }

    writeValue(value: any): void {
        this.selectedEntries = value;
        if(this.select)
            this.select.writeValue(value)
    }

    setDisabledState(isDisabled: boolean): void {
        if(this.select)
            this.select.setDisabledState(isDisabled) // Update the internal state
    }

    updateEntries(value: any) {
        if(value) {
            this.entries = [value];
            this.selectedEntries = value;
            this.select.itemsList.setItems(this.entries)
            this.select.select(this.select.itemsList.items[0])
        }
        else {
            this.entries = [];
            this.selectedEntries = null;
            this.select.itemsList.setItems(this.entries)
        }
    }

}
